import { memo } from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Grid from 'components/Grid';
import times from 'lodash/times';
import { SxProps, useTheme } from '@mui/material';
import { GridProps, GridSize } from '@mui/material/Grid';

interface ICustomMaterialGridProps extends GridProps {
  phxs?: boolean | GridSize;
  ph?: boolean | GridSize;
  phlg?: boolean | GridSize;
  tbxs?: boolean | GridSize;
  tb?: boolean | GridSize;
  tblg?: boolean | GridSize;
  lpxs?: boolean | GridSize;
  lp?: boolean | GridSize;
  lplg?: boolean | GridSize;
  dtxs?: boolean | GridSize;
  dt?: boolean | GridSize;
  dtlg?: boolean | GridSize;
}

interface ItemsSkeletonProps extends ICustomMaterialGridProps {
  count: number;
  spacing: number;
  width?: string | number;
  height?: string | number | object;
  columns?: number;
  animation?: false | 'pulse' | 'wave';
  containerSx: SxProps;
}

const ItemsSkeleton = ({
  count,
  spacing = 0,
  width = '100%',
  height,
  animation = 'wave',
  columns = 12,
  containerSx = {},
  ...gridBreakpoints
}: ItemsSkeletonProps) => {
  const theme = useTheme();
  return (
    <Grid container spacing={spacing} columns={columns} sx={{ ...containerSx }}>
      {times(count, (index) => (
        <Grid item {...gridBreakpoints} width={1} key={`skeleton-item-${index}`}>
          <Box display='flex' position='relative' width={1}>
            <Skeleton
              key={index}
              animation={animation}
              variant='rectangular'
              sx={{
                borderRadius: 3,
                bgcolor: theme.palette.grey[700],
                width: width,
                height: height || theme.spacing(34)
              }}
            />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default memo(ItemsSkeleton);
